import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

function normalizeAxiosError(e) {
    return e?.response?.data?.error || e?.message || "Unbekannter Fehler";
}

export default function useClassifications() {
    const [classifications, setClassifications] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchClassifications = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const res = await axios.get(`${API_BASE}/api/classifications`, { withCredentials: true });
            const data = res.data?.classifications ?? res.data ?? [];
            setClassifications(Array.isArray(data) ? data : []);
        } catch (e) {
            setError(normalizeAxiosError(e));
        } finally {
            setLoading(false);
        }
    }, []);

    const createClassification = useCallback(async (payload) => {
        try {
            const res = await axios.post(`${API_BASE}/api/classifications`, payload, { withCredentials: true });
            await fetchClassifications();
            return res.data?.classification;
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchClassifications]);

    const updateClassification = useCallback(async (id, payload) => {
        try {
            const res = await axios.put(`${API_BASE}/api/classifications/${id}`, payload, { withCredentials: true });
            await fetchClassifications();
            return res.data?.classification;
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchClassifications]);

    const deleteClassification = useCallback(async (id) => {
        try {
            await axios.delete(`${API_BASE}/api/classifications/${id}`, { withCredentials: true });
            await fetchClassifications();
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchClassifications]);

    useEffect(() => {
        fetchClassifications();
    }, [fetchClassifications]);

    return {
        classifications,
        loading,
        error,
        fetchClassifications,
        createClassification,
        updateClassification,
        deleteClassification,
    };
}
